export const CORPORATE_POLICY_EVENTS = {
  CORPORATE_POLICY_FETCH: "corporate-policy-fetch",
  MY_POLICIES_FETCH: "my-policies-fetch",
  CORPORATE_POLICY_FETCH_BY_ID: "corporate-policy-fetch-by-id",
  CORPORATE_POLICY_CREATE: "corporate-policy-create",
  CORPORATE_POLICY_UPDATE: "corporate-policy-update",
  CORPORATE_POLICY_DELETE: "corporate-policy-delete",
  CORPORATE_POLICY_STATUS_TOGGLE: "corporate-policy-status-toggle",
  CORPORATE_POLICY_RULES_CREATE: "corporate-policy-rules-create",
  CORPORATE_POLICY_RULES_UPDATE: "corporate-policy-rules-update",
  CORPORATE_POLICY_RULES_DELETE: "corporate-policy-rules-delete",
};
